import script from "./PopupTool6.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool6.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool6.vue?vue&type=style&index=0&id=9c65371a&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c65371a"]])

export default __exports__